import { useState, useRef, useEffect } from 'react';
import { useWorkspaceNavigate as useNavigate } from '@/contexts/DocumentWorkspace';
import { Bell } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';

export default function NotificationBell() {
  const { notifications, unreadCount, markRead, markAllRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  function openItem(n) {
    if (!n.read_at) markRead(n.id);
    setOpen(false);
    if (n.link) navigate(n.link);
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button aria-label="Notifications" aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen((o) => !o)}
        style={{ position: 'relative', background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, padding: 6 }}>
        <Bell size={18} />
        {unreadCount > 0 && (
          <span style={{ position: 'absolute', top: 0, right: 0, background: '#ef4444', color: '#fff', borderRadius: 999, fontSize: 10, minWidth: 16, height: 16, lineHeight: '16px', textAlign: 'center', padding: '0 4px' }}>
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: 36, width: 320, maxHeight: 400, overflowY: 'auto', background: 'var(--tn-bg, #fff)', border: '1px solid var(--tn-border, #e5e7eb)', borderRadius: 8, boxShadow: 'var(--tn-shadow-md, 0 8px 24px rgba(0,0,0,0.12))', zIndex: 1000 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', borderBottom: '1px solid var(--tn-border, #eee)' }}>
            <strong style={{ fontSize: 14, color: 'var(--tn-ink, #111)' }}>Notifications</strong>
            {unreadCount > 0 && <button onClick={markAllRead} style={{ fontSize: 12, background: 'none', border: 'none', color: 'var(--tn-primary, #4F46E5)', cursor: 'pointer' }}>Mark all read</button>}
          </div>
          {notifications.length === 0 && <div style={{ padding: 16, color: 'var(--tn-muted, #888)', fontSize: 13 }}>No notifications yet.</div>}
          {notifications.slice(0, 8).map((n) => (
            <button key={n.id} onClick={() => openItem(n)}
              style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 12px', border: 'none', borderBottom: '1px solid var(--tn-border, #f3f4f6)', background: n.read_at ? 'var(--tn-bg, #fff)' : 'var(--tn-primary-bg, #eef2ff)', cursor: 'pointer' }}>
              <div style={{ fontSize: 13, fontWeight: n.read_at ? 400 : 600, color: 'var(--tn-ink, #111)' }}>{n.title}</div>
              <div style={{ fontSize: 12, color: 'var(--tn-ink-2, #666)', marginTop: 2 }}>{new Date(n.created_at).toLocaleDateString()}</div>
            </button>
          ))}
          <button onClick={() => { setOpen(false); navigate('/account/notifications'); }}
            style={{ display: 'block', width: '100%', padding: '10px 12px', border: 'none', background: 'var(--tn-bg-2, #fafafa)', color: 'var(--tn-primary, #4F46E5)', fontSize: 13, cursor: 'pointer' }}>
            See all
          </button>
        </div>
      )}
    </div>
  );
}
